import {
  showLine,
  hideLine,
  origin,
  offset,
  duration
} from '@/assets/js/hero/helpers'

const SHOW_DURATION = duration(0.6)
const HIDE_DURATION = duration(0.75)
const SHOW_DURATION_2 = duration(0.37)
const HIDE_DURATION_2 = duration(0.25)

// `hideOffset` is relative to `showOffset`
// all offsets are in percentage
const createDeliveryLine = (
  line,
  { showOffset = 0, hideOffset = 0, showOffset2 = 0, hideScale = 0.2 } = {}
) => (
  new TimelineMax()
    .to(line, SHOW_DURATION, showLine, offset(SHOW_DURATION, showOffset)) // 1
    .set(line, origin('left')) // 2
    .to(
      line,
      HIDE_DURATION - offset(SHOW_DURATION, showOffset) - offset(SHOW_DURATION, hideOffset),
      { scaleX: hideScale },
      `+=${ offset(SHOW_DURATION, hideOffset) }`
    ) // 2
    .to(line, SHOW_DURATION_2, showLine, `+=${ offset(SHOW_DURATION_2, showOffset2) }`) // 3
    .set(line, origin('right')) // 4
    .to(line, HIDE_DURATION_2, hideLine) // 4
    .set(line, origin('left')) // prepare for next timeline
)

export default createDeliveryLine



// WEBPACK FOOTER //
// ./src/assets/js/hero/delivery.js